import Ajax from "Utils/ajax";


export const refreshToken = () => Ajax.get("list/refreshToken");
export const logoutRequest = data => Ajax.post("admin/logout", data);

